<template>
  <div class="kt-grid kt-grid--ver kt-grid--root">
    <h3 style="color: white;">.</h3>
    <div
      class="kt-grid__item kt-grid__item--fluid kt-grid kt-error-v4"
      :style="{
        backgroundImage: `url(${backgroundImage})`
      }"
    >
      <div class="kt-error_container">
        <h1 class="kt-error_number">
          403
        </h1>
        <p class="kt-error_title">
          Access Denied
        </p>
        <p class="kt-error_description">
          You are not authorized to view this page.
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/error/error-4.scss";
</style>

<script>
export default {
  name: "Error-4",
  mounted() {},
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/error/bg5.jpg";
    }
  }
};
</script>
